import { BorderBox, Button } from "../components/index.js";
import ManagedVimeoPlayer from "../components/ManagedVimeoPlayer.jsx";
import { useNavigate } from "react-router-dom";

export default function Welcome() {
  const navigate = useNavigate();

  return (
    <div className={`flex flex-col justify-between h-[calc(100vh-4rem)] pb-4`}>
      <BorderBox padding="p-8" className="flex flex-col">
        <h1 className="text-lz-ink-mid dark:text-lz-concrete text-5xl mb-6">
          Welcome to the Rosicrucian Order
        </h1>
        <ManagedVimeoPlayer
          videoUrl="https://player.vimeo.com/video/1193704419?h=230da62a1f"
          title="Welcome to the Rosicrucian Order"
          className="flex-1 min-h-0 w-full block"
        />
        <Button
          withArrow
          className="mt-6 uppercase w-fit"
          onClick={() => navigate("/degree/mandami")}
        >
          Start Studying
        </Button>
      </BorderBox>
    </div>
  );
}
